var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('ServicePageCover')],1)],1),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('ServicePageList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }